import type * as React from 'react';
import { get } from '@Domain/Api';
import aiModelsFetched, {
	type AiModelsFetchedAction,
	type AiModelsFetchedPayload,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';
import aiModelsFetchFailed, {
	type AiModelsFetchFailedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetchFailed';
import type FetchAiModels from '@Application/Ai/AiConfiguration/Models/Queries/FetchAiModels';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiModelsFetchedAction | AiModelsFetchFailedAction;

export default (query: FetchAiModels) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiModelsFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/ai-models`,
			);

			const action = aiModelsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
